import 'vuetify/styles'
import { createVuetify } from 'vuetify'
// Import only specific icons instead of entire font
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { h } from 'vue'
// import SpringIcon from '@/assets/spring-3.svg?component'
// import SpringBootIcon from '@/assets/spring-boot-1.svg?component'

const customSvgNameToComponent = {
  // 'spring-icon': SpringIcon,
  // 'spring-boot-icon': SpringBootIcon,
}

const customSvgIconset = {
  component: (props) => {
    const getComponent = (comp) => {
      if (comp && typeof comp === 'function') {
        return comp;
      }
      if (comp && comp.default && typeof comp.default === 'function') {
        return comp.default;
      }
      return null;
    };
    const iconComp = getComponent(customSvgNameToComponent[props.icon]);
    if (!iconComp) {
      console.error(`Unknown icon or unable to resolve component: ${props.icon}`);
      return h('span', { class: 'v-icon' });
    }
    return h(iconComp, { class: 'v-icon' });
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#f59e0b',
          secondary: '#21a5a6',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          background: '#f5f5f5',
          surface: '#ffffff',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#f59e0b',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          background: '#0f172a',
          surface: '#1e293b',
        },
      },
    },
  },
  display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      custom: customSvgIconset,
    },
  },
})
